import {Modal, Radio, RadioChangeEvent} from 'antd';
import _ from 'lodash';
import React, {useCallback, useContext, useState} from 'react';
import {QueryField} from '../../../containers/QueryBuilder/types/Query';
import {QueryBuilderContext, QueryBuilderContextType} from '../QueryBuilderContext';
import {isCountOnlyAgg} from "../QueryBuilderUtil";

export const IDENTIFIER_CHOICE = { value: 'count', label: 'Count' }
export const SUM_CHOICE = { value: 'sum', label: 'Sum' }
export const AGG_CHOICES = [
    SUM_CHOICE,
    { value: 'min', label: 'Min' },
    { value: 'max', label: 'Max' },
    { value: 'average', label: 'Average' }
]

export const availableChoices = (code: string, values: QueryField[], current?: string): { value: string; label: string; }[] => {
    const reject = _.filter(values, { code: code })
    if (reject && reject.length > 0) {
        const currentChoice = _.find(AGG_CHOICES, { value: current })
        const accept = _.difference(AGG_CHOICES.map(i => i.value), reject.map(i => i.aggtype!))
        const availableChoices = _.filter(AGG_CHOICES, function (o) {
            const r = _.filter(accept, (i) => i === o.value)
            return r.length > 0
        })

        if (currentChoice) {
            availableChoices.push(currentChoice)
        }

        return availableChoices
    } else {
        return AGG_CHOICES
    }
}

const ValueDialog: React.FC = () => {

    const {
        userQuery,
        currentField,
        setCurrentField,
        isValueModalOpen,
        setIsValueModalOpen
    } = useContext(QueryBuilderContext) as QueryBuilderContextType

    const cf = currentField!

    const choices = availableChoices(cf.field.code, userQuery.query.values, cf.queryField?.aggtype).map(i => i.value)

    const getAggTypeForField = (): string => {
        // find the available aggtype
        let aggtype = choices.length > 0 ? choices[0] : AGG_CHOICES[0].value
        if (cf.queryField && cf.queryField.aggtype) {
            aggtype = cf.queryField.aggtype
        }
        if (isCountOnlyAgg(cf.field)) {
            aggtype = IDENTIFIER_CHOICE.value
        }
        return aggtype
    }

    const [value, setValue] = useState(getAggTypeForField())
    const setAggTypeForField = useCallback(() => {
        let index = _.findIndex(userQuery.query.values, { code: cf.field.code, aggtype: cf.queryField?.aggtype })
        if (index < 0) {
            index = _.findIndex(userQuery.query.values, { code: cf.field.code })
        }
        userQuery.query.values[index].aggtype = value
    }, [cf.field.code, userQuery.query.values, value, cf.queryField?.aggtype])

    const handleOk = () => {
        setCurrentField(undefined)
        setIsValueModalOpen(false)
        setAggTypeForField()
    }

    const handleCancel = () => {
        setCurrentField(undefined)
        setIsValueModalOpen(false)
    }

    return (<>
        <Modal
            title={`${cf.field.name}`}
            open={isValueModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}>
            <Radio.Group onChange={(e: RadioChangeEvent) => setValue(e.target.value)} value={value}>
                {AGG_CHOICES.map(i => <Radio key={i.value} value={i.value} disabled={!choices.includes(i.value)}>{i.label}</Radio>)}
            </Radio.Group>
        </Modal>
    </>
    )
}

export default ValueDialog